import {
    apiRequest,
    pengalamanKerjaList,
    pengalamanKerjaActive,
    pengalamanKerjaInactive
} from "../../../../../services/adapters/kepegawaian/pengalamanKerjaService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", pengalamanKerjaList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", pengalamanKerjaInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", pengalamanKerjaActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository